export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-collection/src/values.js
// module id = 243
// module chunks = 0 1 2 3 4